import BlogService from "../../../services/api/blog.service";
import BlogFooterService from "../../../services/api/blogfooter.service";
import {
  Button,
  CloseButton,
  ModalContainer,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  ModalTitle,
} from "../../../style/admin/BlogCreateModal_Style";
import { toast } from "../../../utils/notify";

interface ConfirmDeleteModalProps {
  open: boolean;
  blogId: string | null;

  title?: string;
  description?: string;
  onClose: () => void;
  onConfirm: () => void;
}

const ConfirmDeleteModalBlogFooter: React.FC<ConfirmDeleteModalProps> = ({
  open,
  blogId,
  title = "Xác nhận xóa",
  description = "Bạn có chắc chắn muốn xóa blog này không?",
  onClose,
  onConfirm,
}) => {
  if (!open) return null;

  const handleDelete = async (id: string) => {
    const res = await BlogFooterService.deletes(id);
    if (res.success) {
      toast(res.message ?? "", "success");
    } else {
      toast(res.message ?? "", "error");
    }
    onConfirm();
  };

  return (
    <ModalOverlay>
      <ModalContainer style={{ maxWidth: 420 }}>
        <ModalHeader>
          <ModalTitle>{title}</ModalTitle>
          <CloseButton onClick={onClose}>✕</CloseButton>
        </ModalHeader>

        <div style={{ padding: "16px 0", color: "#374151" }}>{description}</div>

        <ModalFooter>
          <Button type="button" className="cancel" onClick={onClose}>
            Hủy
          </Button>
          <Button
            type="button"
            style={{ background: "#ef4444" }}
            onClick={() => blogId && handleDelete(blogId)}>
            Xóa
          </Button>
        </ModalFooter>
      </ModalContainer>
    </ModalOverlay>
  );
};

export default ConfirmDeleteModalBlogFooter;
